import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, accent, sub, children, dataTestId }) {
    return (
        <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden" data-testid={dataTestId || "page-hero"}>
            <div className="absolute inset-0 hero-glow-bg pointer-events-none" />
            <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                    {eyebrow && <div className="overline mb-4">{eyebrow}</div>}
                    <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-[3.25rem] leading-[1.04] tracking-tight text-ink max-w-4xl">
                        {title}
                        {accent && <> <span className="brand-gradient-text">{accent}</span></>}
                    </h1>
                    {sub && <p className="mt-6 text-base md:text-lg text-muted-ink max-w-2xl leading-relaxed">{sub}</p>}
                    {children && <div className="mt-9">{children}</div>}
                </motion.div>
            </div>
        </section>
    );
}
